var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44 20.74a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4.2a.5.5 0 0 1-.48-.34l-2.2-6.6a3 3 0 0 0-2.84-2H13.72a3 3 0 0 0-2.84 2l-2.2 6.6a.5.5 0 0 1-.48.34H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1.38a.52.52 0 0 1 .46.32.5.5 0 0 1 0 .54l-3.26 3.14A2.1 2.1 0 0 0 2 26.16v6.58a2 2 0 0 0 1.2 1.8.5.5 0 0 1 .3.46v4.76a2.52 2.52 0 0 0 2.5 2.5h4a2.52 2.52 0 0 0 2.5-2.5v-4.52a.5.5 0 0 1 .5-.5h22a.5.5 0 0 1 .5.5v4.52a2.52 2.52 0 0 0 2.5 2.5h4a2.52 2.52 0 0 0 2.5-2.5V35a.5.5 0 0 1 .3-.46 2 2 0 0 0 1.2-1.8v-6.58a2.1 2.1 0 0 0-.58-1.42l-3.16-3.14a.5.5 0 0 1-.1-.54.52.52 0 0 1 .46-.32Zm-10.8-11a.52.52 0 0 1 .48.36l2.32 7a.44.44 0 0 1 0 .44.46.46 0 0 1-.4.2H12.46a.46.46 0 0 1-.4-.2.44.44 0 0 1 0-.44l2.32-7a.52.52 0 0 1 .48-.36Zm-21.2 20H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Zm23-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.a0ed84c5.svg";
export { ForwardRef as ReactComponent };